import { GameMode } from "../enums";

export const GameModeName = {
  [GameMode.Fun]: 'fun',
  [GameMode.Real]: 'real'
}
